import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";

const CALENDLY_URL = "https://calendly.com/jeremy-alphasignalsport/30min";

export function ScheduleCallCTA() {
  const { translate } = useTranslation();

  return (
    <section id="contact" className="py-20 relative overflow-hidden bg-gradient-to-r from-primary to-secondary">
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center space-y-6 text-primary-foreground">
          <h2 className="text-3xl md:text-4xl font-bold whitespace-pre-line">
            {translate("marketing_cta_title")}
          </h2>
          <p className="text-lg opacity-90">
            {translate("marketing_cta_description")}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button
              size="lg"
              variant="secondary"
              onClick={() => window.open(CALENDLY_URL, "_blank")}
            >
              Schedule a Call
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
